export default class CommunicationToolDetailController {
  /* @ngInject */
  constructor(RouterService, CommunicationToolService, ModalFactory, ProductService, HttpService) {
    this.routerService = RouterService;
    this.communicationToolService = CommunicationToolService;
    this.modalFactory = ModalFactory;
    this.productService = ProductService;
    this.httpService = HttpService;
  }

  $onInit() {
    const {itemId} = this.routerService.state.params;
    this.communicationToolService.item(itemId).then((newItem) => {
      const productPromises = newItem.relatedProducts.map(id => this.productService.get(id));
      this.item = newItem;
      this.httpService.all(productPromises).then(products => this.relatedProducts = products);
      const collection = this.item ? this.item.collection : {};
      this.breadcrumbs = [{label: 'Communication Tools'}, collection, this.item];
    });
  }

  showModalZoomImage() {
    if (this.item.cover.isMedia) {
      return;
    }
    this.modalFactory.showZoomImage({
      activeImage: this.item.cover,
      images: [this.item.cover],
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/communication-tool/communication-tool-detail/communication-tool-detail.controller.js